import React from 'react';

export const Call = (props) => (
  <svg
    fill="none"
    height="24"
    viewBox="0 0 24 24"
    width="24"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      clipRule="evenodd"
      d="M8.1269 15.8727C5.20532 12.9502 3.2953 10.2861 2.44899 7.95323C1.79521 6.14825 2.03907 5.20244 2.06956 5.10056L2.0872 5.03718L2.1225 4.98103C2.17224 4.90081 3.36509 3.00036 5.59037 2.04011L5.68423 2H5.78531C5.88237 2 6.39818 2.03289 6.93966 2.6891C7.36482 3.20493 9.12483 5.60675 9.20023 5.70864C9.24195 5.7696 10.1123 7.03389 9.42485 8.18186C9.05825 8.79074 8.6395 9.47262 8.41329 9.84325C8.7486 10.3005 9.58529 11.3707 11.1078 12.8925C12.6296 14.4151 13.6997 15.2518 14.1562 15.5863C14.526 15.3593 15.2086 14.9421 15.8183 14.5755C16.1103 14.4006 16.4384 14.3124 16.7914 14.3124C17.5735 14.3124 18.2129 14.7448 18.2834 14.7953C18.3925 14.8755 20.7959 16.6348 21.3109 17.0608C21.9663 17.6023 22 18.1181 22 18.216V18.3162L21.9599 18.4093C20.9989 20.6354 19.0993 21.8275 19.0191 21.8781L18.9613 21.9126L18.8987 21.9318C18.8602 21.943 18.646 22 18.2602 22C16.7649 22 13.4599 21.2042 8.1269 15.8727Z"
      fill="white"
      fillRule="evenodd"
      stroke="black"
      strokeWidth="1.5"
    />
  </svg>
);
